<ng-container *ngIf="property != null && data != null && property.hidden == false">
    <div style="vertical-align: text-top" class="row">
        <!-- Property Name-->
		<div class="objectParam parameterLabel col-sm-4"
                [ngClass]="{ 'labelRequired': property?.required, 'labelNormal': !property?.required }"
                [ngStyle]="property?.required ? { 'font-weight': '600' } : {}">
            {{property?.name}}
        </div>

        <!-- Data Values -->
        <div class="col-sm-8">
            <ng-container *ngFor="let datum of data; let i = index">
                <div class="row">
                    <!-- Multi-value Property Buttons (Add / Remove)-->
                    <div class="col-sm-1">
                        <ng-container *ngIf="property?.multiple">
                            <ng-container *ngIf="i == 0">
                                <button class="btn btn-ef" (click)="addNewValue()">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </ng-container>
                            <ng-container *ngIf="i > 0">
                                <button class="btn btn-default" (click)="removeValueAtIndex(i)">
                                    <i class="fa fa-minus"></i>
                                </button>
                            </ng-container>
                        </ng-container>
                    </div>

                    <!-- Data Display (depends on Property Type) -->
                    <div class="col-sm-11">
                        <ng-container [ngSwitch]="property?.type">

                            <!-- ANTENNA-->
                            <ng-container *ngSwitchCase="propertyType.ANTENNA_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Antenna name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- BOOLEAN -->
                            <ng-container *ngSwitchCase="propertyType.BOOLEAN">
                                <input class="form-control" type="checkbox" [(ngModel)]="datum.object_value" (ngModelChange)="onBooleanChanged(datum)"  [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- CHARACTER -->
                            <ng-container *ngSwitchCase="propertyType.CHARACTER">
                                <input class="form-control" type="text" maxlength="1" [(ngModel)]="datum.value" (ngModelChange)="onStringChanged(datum)" [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- DOUBLE (Same as [FLOAT, INTEGER, LONG, SHORT])-->
                            <ng-container *ngSwitchCase="propertyType.DOUBLE">
                                <input class="form-control" type="number" inputmode="numeric" [(ngModel)]="datum.object_value" (ngModelChange)="onDoubleChanged(datum)"  [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- DRIVER OBJECT -->
                            <ng-container *ngSwitchCase="propertyType.DRIVEROBJECT_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- EMAIL (Same as [STRING]) -->
                            <ng-container *ngSwitchCase="propertyType.EMAIL">
                                <input class="form-control" type="text" [(ngModel)]="datum.value" (ngModelChange)="onStringChanged(datum)" [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- FLOAT (Same as [DOUBLE, INTEGER, LONG, SHORT])-->
                            <ng-container *ngSwitchCase="propertyType.FLOAT">
                                <input class="form-control" type="number" inputmode="numeric" [(ngModel)]="datum.object_value" (ngModelChange)="onDoubleChanged(datum)"  [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- GROUP -->
                            <ng-container *ngSwitchCase="propertyType.GROUP_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Group name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- IMAGE -->
                            <ng-container *ngSwitchCase="propertyType.IMAGE_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Image name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                                <img [src]="getImagePath(datum)" style="max-width: 40px; max-height: 40px" />   
                            </ng-container>

                            <!-- INTEGER (Same as [DOUBLE, FLOAT, LONG, SHORT])-->
                            <ng-container *ngSwitchCase='propertyType.INTEGER'>
                                <input class="form-control" type="number" inputmode="numeric" [(ngModel)]="datum.object_value" (ngModelChange)="onDoubleChanged(datum)"  [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- LOCATION-->
                            <ng-container *ngSwitchCase="propertyType.LOCATION_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Location name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- LONG (Same as [DOUBLE, FLOAT, INTEGER, SHORT])-->
                            <ng-container *ngSwitchCase='propertyType.LONG'>
                                <input class="form-control" type="number" inputmode="numeric" [(ngModel)]="datum.object_value" (ngModelChange)="onDoubleChanged(datum)"  [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- OBJECT -->
                            <ng-container *ngSwitchCase="propertyType.OBJECT_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Object name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- READER -->
                            <ng-container *ngSwitchCase="propertyType.READER_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Reader name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- SERVER OBJECT -->
                            <ng-container *ngSwitchCase="propertyType.SERVEROBJECT_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- SERVICE -->
                            <ng-container *ngSwitchCase="propertyType.SERVICE_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Service Name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- SHORT (Same as [DOUBLE, FLOAT, INTEGER, LONG])-->
                            <ng-container *ngSwitchCase="propertyType.SHORT">
                                <input class="form-control" type="number" inputmode="numeric" [(ngModel)]="datum.object_value" (ngModelChange)="onDoubleChanged(datum)"  [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- STRING (Same as [EMAIL])-->
                            <ng-container *ngSwitchCase="propertyType.STRING">
                                <input class="form-control" type="text" [(ngModel)]="datum.value" (ngModelChange)="onStringChanged(datum)" [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                            </ng-container>

                            <!-- TAG -->
                            <ng-container *ngSwitchCase="propertyType.TAG_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Tag Instance name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- USERS -->
                            <ng-container *ngSwitchCase="propertyType.USER_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.lastName || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'lastName'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by User Last Name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>

                            <!-- ZONE -->
                            <ng-container *ngSwitchCase="propertyType.ZONE_REFERENCE">
                                <input
                                    type="text"
                                    [ngModel]="datum.object_value?.name || ''"
                                    (ngModelChange)="onInputChange($event, datum)"
                                    [typeahead]="datum.instanceResults$"
                                    [typeaheadAsync]="true"
                                    [typeaheadOptionField]="'name'"
                                    (typeaheadOnSelect)="onInstanceSelected($event, datum)"
                                    class="form-control"
                                    placeholder="Search by Zone name..."
                                    [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly"
                                />
                            </ng-container>
                            
                            <!-- OBJECT TYPE (EmObject definition, not instance) -->
							<ng-container *ngSwitchCase="propertyType.OBJECTTYPE_REFERENCE">
    							<input
        							type="text"
        							[ngModel]="datum.object_value?.name || ''"
        							(ngModelChange)="onInputChange($event, datum)"
        							[typeahead]="datum.instanceResults$"
        							[typeaheadAsync]="true"
        							[typeaheadOptionField]="'name'"
        							(typeaheadOnSelect)="onInstanceSelected($event, datum)"
        							class="form-control"
        							placeholder="Search by Object Type name..."
        							[tooltip]="property?.helpText"
        							[delay]="1000"
        							[readonly]="!isCreate && property?.readonly"
        							[disabled]="!isCreate && property?.readonly"
    							/>
							</ng-container>
                            

                            <!-- DEFAULT / UNKNOWN (Model as String with warning)-->
                            <ng-container *ngSwitchDefault>
                                <div class="col-sm-6">
                                    <input class="form-control" type="text" [(ngModel)]="datum.value" [tooltip]="property?.helpText" [delay]="1000" [readonly]="!isCreate && property?.readonly" [disabled]="!isCreate && property?.readonly">
                                </div>
                                <div class="col-sm-6">
                                    <span>[UNKNOWN TYPE: {{property?.type}}]</span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="property == null || data == null">
    NO DATA TO DISPLAY!
</ng-container>